import _ from "lodash";

import AmpersandState from 'ampersand-state';

const NoteTypeModel = AmpersandState.extend({

    idAttribute: 'id',

    props: {
        id: 'string',
        companyId: 'string',
        name: 'string',
        icon: 'string', // class name
        description: 'string',
        isDeleted: 'boolean',
        sortPosition: 'number',
    },

    parse(obj) {
        return obj;
    },

});

module.exports = NoteTypeModel;